module.exports = __webpack_public_path__ + "assets/pix.386eb093.svg";